import React, { PropsWithChildren } from 'react';
import copyPng from "../../../images/copy.png";

export default function CopyActionWrapper({ children }: PropsWithChildren) {

    function copyToClipboard() {
        navigator.clipboard.writeText(children as string);
    }

    return (
        <>
            <span data-testid='copy-text-test' >{children}</span>
            <img src={copyPng} className="copy-icon" onClick={copyToClipboard} data-testid='copy-icon-test' />
        </>
    );
}